import { Dimmer, Grid, Loader, Message } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import { AccordionList } from '@/components/Autre/AccordionList';
import { RecuContextProvider } from '@/components/Context';
import { LoadingContext, PayeurContext } from '@/contexts';
import FactureAccordionContent from '../../FactureAccordionList/FactureAccordionContent';
import FactureAccordionTitle from '../../FactureAccordionList/FactureAccordionTitle';

const PayeurPanelFactures = () => {
  const { factures } = React.useContext(PayeurContext);
  const {
    payeurLoadings: { factures: loading },
  } = React.useContext(LoadingContext);

  const itemHasContent = React.useCallback((facture) => {
    const nonEncaissee = _.every(facture.lignes, (ligne) => _.isEmpty(ligne.lignesRecu));

    return !nonEncaissee;
  }, []);

  if (loading) {
    return (
      <Grid style={{ height: 100 }}>
        <Grid.Row textAlign="center">
          <Grid.Column textAlign="center">
            <Dimmer active inverted>
              <Loader>Chargement des factures</Loader>
            </Dimmer>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  if (_.size(factures) === 0) {
    return (
      <Grid>
        <Grid.Row textAlign="center">
          <Grid.Column textAlign="center">
            <Message>Ce payeur n&apos;a actuellement aucune facture attribuée</Message>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  return (
    <RecuContextProvider standAlone>
      <AccordionList
        items={factures}
        itemHasContent={itemHasContent}
        title={FactureAccordionTitle}
        content={FactureAccordionContent}
      />
    </RecuContextProvider>
  );
};

export default PayeurPanelFactures;
